import React from 'react';
import './SocialLinks.css';

class SocialLinks extends React.Component {
  render() {
    const links = [
      {
        title: 'Twitter',
        icon: 'twitter-icon',
        url: 'https://twitter.com/w3debugger'
      }, {
        title: 'Dribbble',
        icon: 'dribbble-icon',
        url: 'https://dribbble.com/w3debugger'
      }, {
        title: 'LinkedIn',
        icon: 'linkedin-icon',
        url: 'https://ae.linkedin.com/in/w3debugger'
      }
    ];
    const socialLinks = links.map((link, i) => {
      return (
        <a className="social-item" href={link.url} title={link.title} key={i}>
          <svg className={link.icon + ' social-item-icon'}>
            <use xlinkHref={'#' + link.icon}></use>
          </svg>
        </a>
      )
    });

    return <nav className="social">{socialLinks}</nav>;
  }
}

export default SocialLinks;



// WEBPACK FOOTER //
// ./src/Shared/SocialLinks.js